// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { BoundedGrid } from "./BoundedGrid";
import {
  BoundedGridFromJSON,
  BoundedGridFromJSONTyped,
  BoundedGridToJSON,
  BoundedGridToJSONTyped,
} from "./BoundedGrid";
import type { RasterLayer } from "./RasterLayer";
import {
  RasterLayerFromJSON,
  RasterLayerFromJSONTyped,
  RasterLayerToJSON,
  RasterLayerToJSONTyped,
} from "./RasterLayer";
import type { BoundedTimeAxis } from "./BoundedTimeAxis";
import {
  BoundedTimeAxisFromJSON,
  BoundedTimeAxisFromJSONTyped,
  BoundedTimeAxisToJSON,
  BoundedTimeAxisToJSONTyped,
} from "./BoundedTimeAxis";

/**
 *
 * @export
 * @interface RasterSeriesMeta
 */
export interface RasterSeriesMeta {
  /**
   *
   */
  grid: BoundedGrid;
  /**
   *
   */
  time: BoundedTimeAxis;
  /**
   *
   */
  layers: Array<RasterLayer>;
}

/**
 * Check if a given object implements the RasterSeriesMeta interface.
 */
export function instanceOfRasterSeriesMeta(value: object): value is RasterSeriesMeta {
  if (!("grid" in value) || value["grid"] === undefined) return false;
  if (!("time" in value) || value["time"] === undefined) return false;
  if (!("layers" in value) || value["layers"] === undefined) return false;
  return true;
}

export function RasterSeriesMetaFromJSON(json: any): RasterSeriesMeta {
  return RasterSeriesMetaFromJSONTyped(json, false);
}

export function RasterSeriesMetaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RasterSeriesMeta {
  if (json == null) {
    return json;
  }
  return {
    grid: BoundedGridFromJSON(json["grid"]),
    time: BoundedTimeAxisFromJSON(json["time"]),
    layers: (json["layers"] as Array<any>).map(RasterLayerFromJSON),
  };
}

export function RasterSeriesMetaToJSON(json: any): RasterSeriesMeta {
  return RasterSeriesMetaToJSONTyped(json, false);
}

export function RasterSeriesMetaToJSONTyped(
  value?: RasterSeriesMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    grid: BoundedGridToJSON(value["grid"]),
    time: BoundedTimeAxisToJSON(value["time"]),
    layers: (value["layers"] as Array<any>).map(RasterLayerToJSON),
  };
}
